import { Box, Card, CardContent, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useContext, useState } from 'react';
import { ThemeContext } from '@f_context/Theme_context';
import stls from '@f_crossdata/styles/components/licenses/Subscription.module.sass';
import { LayoutPage } from '@f_crossdata/general/LayoutPage';
import { FormikWrapper } from '@f_general/formik/FormikWrapper';
import { FormikController } from '@f_general/formik/FormikController';
import { UserContext } from '@f_context/User_context';
import { isEmpty } from 'lodash';
import { CrossdataContext } from '@f_crossdata/context/Crossdata_context';
import { Alert } from '@f_general/alert';
import { choosenTariffQwepCustomerSchema } from '@f_general/formik/helpers/ValidationSchema';
import { IconData } from '../../icons/IconData';
import { GeneralContext } from '../../../../../src/context/General_context';
import { color } from '@mui/system';
// import { Data } from './Data';

export function Subscription() {
    const { t } = useTranslation();
    const { colors } = useContext(ThemeContext);
    const { userInfo } = useContext(UserContext);
    const { changeTariff, activeApp, blocked } = useContext(CrossdataContext);
    const { colorTheme } = useContext(GeneralContext);
    const [data, setData] = useState({
        phone: userInfo.phoneNumber ?? '',
        name: userInfo.firstName ?? '',
        comment: '',
    });
    const background = colorTheme === 'light' ? 'white' : '#2E303F';
    const colorText = colorTheme === 'light' ? '#A9C1CF' : '#A9C1CF';

    
    const submitHandler = async (values: any) => {
        const result = await changeTariff(values);
        if (result.isOk) {
            setData({
                phone: userInfo.phoneNumber ?? '',
                name: userInfo.firstName ?? '',
                comment: '',
            });
            Alert({
                type: 'success',
                text: t('general.success'),
            });
        } else {
            Alert({
                type: 'error',
                text: t('general.error'),
            });
        }
    };

    return (
        <LayoutPage>
            <Box className={stls.subscription}>
                <Card className={stls.subscriptionCard}>
                    <CardContent className={stls.licensesContent}>
                        {!isEmpty(userInfo) && (
                            <FormikWrapper
                                onSubmit={submitHandler}
                                initialValues={data}
                                validShema={choosenTariffQwepCustomerSchema}>
                                <div className={stls.title}>
                                    <IconData /> {t('crossdata.subscription.title')}
                                </div>
                                <div className={stls.description}>{t('crossdata.subscription.description')}</div>
                                <div className={stls.fillForm}>{t('crossdata.subscription.fillForm')}</div>
                                <div className={stls.textField}>
                                    <Typography sx={{ color: '#fff', fontWeight: 800 }}>{t('auth.phone')}*</Typography>
                                    <FormikController
                                        className={stls.input}
                                        type="tel"
                                        castomStyle={{
                                            '& .MuiInputBase-input': {
                                                background: background,
                                                borderRadius: '12px',
                                                padding: '12px',
                                                color: colorText,
                                            },
                                        }}
                                        control="input"
                                        name="phone"
                                        placeholder="+7 (999) 000-00-00"
                                    />
                                </div>
                                <div className={stls.textField}>
                                    <Typography sx={{ color: '#fff', fontWeight: 800 }}>{t('auth.name')}*</Typography>

                                    <FormikController
                                        className={stls.input}
                                        castomStyle={{
                                            '& .MuiInputBase-input': {
                                                background: background,
                                                borderRadius: '12px',
                                                color: colorText,
                                            },
                                        }}
                                        type="text"
                                        control="input"
                                        name="name"
                                        placeholder={t('crossdata.subscription.name')}
                                    />
                                </div>

                                <div className={stls.textField}>
                                    <Typography sx={{ color: '#fff', fontWeight: 800 }}>
                                        {t('licenses.comment')}
                                    </Typography>
                                    <FormikController
                                        className={stls.input}
                                        type="text"
                                        control="input"
                                        rows={4}
                                        multiline
                                        castomStyle={{
                                            '& .MuiInputBase-root': {
                                                background: background,
                                                borderRadius: '12px',
                                                color: colorText,
                                                paddind: '0px',
                                                fontWeight: 400,
                                                fontFamily: 'Inter',
                                            },
                                            '& .MuiInputBase-input': {
                                                color: colorText,
                                                padding: '0px',
                                            },
                                        }}
                                        name="comment"
                                        placeholder={t('licenses.enterComment')}
                                    />
                                </div>

                                <Button
                                    className={stls.button}
                                    size="large"
                                    variant="contained"
                                    type="submit"
                                    style={{ background: '#ffff', color: '#3B82F6' }}>
                                    {t('licenses.confirm')}
                                </Button>
                            </FormikWrapper>
                        )}
                    </CardContent>
                </Card>
                <div>
                    {blocked && <p style={{ color: colors.lambda }}>{t('crossdata.subscription.appBlock')}</p>}
                    {!activeApp && <p style={{ color: colors.lambda }}>{t('crossdata.subscription.subscPeriodEnd')}</p>}
                </div>
            </Box>
            {/* < Data />   */}
        </LayoutPage>
    );
}
